module.exports = __webpack_public_path__ + "img/55382F_78554E_271A16_6C4C44-256px.6ac6996c.png";